(function () {
  const sliderWithContent = () => {
    $(".section-slider-with-content").each(function () {
      if ($(this).hasClass("slider_started")) {
        return;
      }
      $(this).addClass("slider_started");
      const id = $(this).attr("id");
      const box = $(this).find(".slider-with-content");
      const autoplay = box.data("autoplay");
      const stopAutoplay = box.data("stop-autoplay");
      const delay = box.data("delay") * 1000;
      const speed = box.data("speed") * 1000;

      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      } else {
        autoplayParm = {};
      }

      const swiperParms = {
        effect: box.data("effect"),
        speed: speed,
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: false,
        keyboard: true,
        navigation: {
          nextEl: `#${id} .swiper-btn--next`,
          prevEl: `#${id} .swiper-btn--prev`,
        },
        pagination: {
          el: `#${id} .swiper-pagination`,
          renderBullet: function (index, className) {
            return (
              '<span class="' + className + '">' + "0" + (index + 1) + "</span>"
            );
          },
        },
        on: {
          init: function () {},
          slideChangeTransitionStart: function (swiper) {
            let bullets = document.querySelectorAll(
              `#${id} .swiper-pagination-bullet`
            );
            let activeIndex = swiper.realIndex;

            bullets.forEach((bullet, index) => {
              bullet.classList.remove("prev", "next");
              if (index === activeIndex - 1) {
                bullet.classList.add("prev");
              }
              if (index === activeIndex + 1) {
                bullet.classList.add("next");
              }
            });
          },
          slideNextTransitionStart: function () {
            let bullets = document.querySelector(
              `#${id} .swiper-pagination-bullet.next`
            );
            let x = document.querySelectorAll(
              `#${id} .swiper-pagination-bullet`
            );

            if (autoplay) {
              if (bullets) {
                bullets.classList.add("opacity-0");
                setTimeout(() => {
                  bullets.classList.remove("opacity-0");
                }, speed);
              }

              if (
                x[x.length - 1].classList.contains(
                  "swiper-pagination-bullet-active"
                ) &&
                x.length == 3
              ) {
                setTimeout(() => {
                  x[1].classList.remove("prev");
                  //x[x.length - 1].classList.add('prev')
                }, speed);
              }
            }
          },
          slidePrevTransitionStart: function () {
            let bullets = document.querySelector(
              `#${id} .swiper-pagination-bullet.prev`
            );
            if (!autoplay) {
              if (bullets) {
                bullets.classList.add("opacity-0");
                setTimeout(() => {
                  bullets.classList.remove("opacity-0");
                }, speed);
              }
            }
          },
        },
        ...autoplayParm,
      };

      new Swiper(`#${id} .swiper`, swiperParms);
    });
  };

  sliderWithContent();

  document.addEventListener("shopify:section:load", function () {
    sliderWithContent();
  });
})();
